<template>

    <div class="h-full flex items-center bg-gray-500">

        <img class="absolute w-full opacity-50" src="../assets/img/bg4.jpg" alt="">

        <div class="w-full z-50">
            <div class="w-full max-w-xs mx-auto">

                <div class="bg-white shadow-md rounded pt-8">
                    <div class="mb-4">
                        <img class="w-3/12 mx-auto mb-6" src="../assets/img/ezilly-logo.png">
                        <div class="text-2xl text-center text-gray-800" style="font-family: 'M7 Sans'">MARKTIME</div>
                    </div>
                    <form class="px-8 pt-6 pb-8 mb-4" @submit.prevent="login">
                        <div class="mb-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
                                Email
                            </label>
                            <input v-model="email" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="email" placeholder="Email">
                        </div>
                        <div class="mb-6">
                            <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
                                Password
                            </label>
                            <input v-model="password" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" type="password" placeholder="password">
                            <p class="text-red-500 text-xs italic hidden">Please choose a password.</p>
                        </div>
                        <button class="btn btn-primary w-full">
                            <div v-if="loading" class="loader"></div>
                                            <span v-else>Sign In</span>
                        </button>
                    </form>
                </div>


            </div>
            <div class="flex flex-col">
                <div class="p-5 bg-red-200 text-red-800 mb-4 w-5/12 mx-auto text-center" v-if="errorMessage">
                    {{ errorMessage }}
                </div>
                <p class="text-center text-white text-xs">
                    &copy;{{ actualYear }} UX/UI TEAM Ezilly CZ, All rights reserved.
                </p>
            </div>
        </div>
    </div>

</template>

<script>
import { auth } from '@/firebase'

export default {
    data() {
        return {
            email: "",
            password: "",
            errorMessage: null,
            loading: 0,
            actualYear: new Date().getFullYear()
        }
    },
    methods: {
        login() {
            this.loading = 1
            auth.signInWithEmailAndPassword(this.email, this.password).then(
                user => {
                    if (this.email === 'calendar@ezilly.nl') {
                        this.$router.replace({
                            name: 'vacationsCalendar'
                        })
                    } else {
                        this.$router.replace({
                            name: 'marktime-list'
                        })
                    }
                    this.loading = 0
                },
                error => {
                    this.errorMessage = error.message
                    this.loading = 0
                }
            );
        }
    }
}

</script>